<template>
    <div class="purchase-course vod">

        <template v-if="isLean">
            <template v-if="isAuth">
                <template v-if="vodCourse.isUserEnrolled">
                    <a :href="vodCourse.classroomUri" class="btn btn-primary mt-3">Begin Course</a>
                </template>
                <template v-else>
                    <template v-if="isFree">
                        <enrol-vod-course-button-component
                            :vod-course="vodCourse"
                            :slug="vodCourse.slug"
                            :user="user"
                            :purchase-intent="'free'">Start Course</enrol-vod-course-button-component>
                    </template>
                    <template v-else>
                        <template v-if="isSubscribed && userTier == 'premium'">
                            <enrol-vod-course-button-component
                                :vod-course="vodCourse"
                                :slug="vodCourse.slug"
                                :user="user"
                                :purchase-intent="'subscribed'">Take Course</enrol-vod-course-button-component>
                        </template>
                        <template v-else>
                            <button @click="buyClick" class="btn btn-primary btn-slimpad btn-block btn-white">Buy Now</button>
                        </template>
                    </template>
                </template>
            </template>
            <template v-else>
                <a :href="'/subscribe?return=' + vodCourse.uri" class="btn btn-primary btn-slimpad btn-block btn-white btn-lean-bot">Upgrade membership</a>
            </template>
        </template>
        <template v-else>

            <!-- ENROLLED -->
            <template v-if="vodCourse.isUserEnrolled">
                <div class="mt-3 text-center">
                    <h3 class="notif mb-0">
                        You're already on this course, let's get started.
                    </h3>
                    <a :href="vodCourse.classroomUri" class="btn btn-primary mt-3">Begin Course</a>
                </div>
            </template>
            <template v-else>
                <!-- FREE -->
                <template v-if="isFree">
                    <div class="row justify-content-center">
                        <div class="col-md-10">
                            <div class="block left">
                                <div class="row">
                                    <div class="col-12 col-lg-8">
                                        <h3>
                                            Free Course
                                        </h3>

                                        <p>This is a free course, you just need an account to take it.</p>
                                    </div>
                                    <div class="col-12 col-lg-4 meta-col d-flex align-items-stretch">
                                        <div class="meta-info">
                                            <template v-if="!vodCourse.isUserEnrolled">
                                                <template v-if="!isAuth">
                                                    <a :href="'/register?return=' + vodCourse.uri" class="btn btn-primary btn-slimpad btn-block btn-white">Sign Up</a>
                                                </template>
                                                <template v-else>
                                                    <enrol-vod-course-button-component
                                                        :vod-course="vodCourse"
                                                        :slug="vodCourse.slug"
                                                        :user="user"
                                                        :purchase-intent="'free'">Start Course</enrol-vod-course-button-component>
                                                </template>
                                            </template>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </template>
                <!-- EO FREE -->
                <!-- PAID -->
                <template v-else>

                    <!-- Show the Membership box -->
                    <div class="row justify-content-center">
                        <div class="col-md-10">
                            <div class="block left">
                                <div class="row">
                                    <div class="col-12 col-lg-7">
                                        <template v-if="!(isSubscribed && userTier == 'premium')">
                                            <h3>
                                                Included in membership
                                            </h3>

                                            <p>What's included:</p>
                                            <ul>
                                                <li>Unlimited access to bite-sized Classes</li>
                                                <li>Access to all in-depth, expert-led courses</li>
                                                <li>10% off Music Feedback from Artists</li>
                                                <li>Learn with leading artists and experts</li>
                                                <li>£14.99/month — cancel anytime.</li>
                                            </ul>
                                        </template>
                                        <template v-else>
                                            <h3>
                                                Are you ready to<br class="d-none d-md-inline" /> take this course?
                                            </h3>
                                        </template>
                                    </div>
                                    <div class="col-12 col-lg-5 meta-col d-flex align-items-stretch">
                                        <div class="meta-info">
                                            <template v-if="isSubscribed && userTier == 'premium'">
                                                <template v-if="!isFreemiumUser || (isFreemiumUser && vodCourse.is_freemium)">
                                                    <enrol-vod-course-button-component
                                                        :vod-course="vodCourse"
                                                        :slug="vodCourse.slug"
                                                        :user="user"
                                                        :purchase-intent="'subscribed'">Take Course</enrol-vod-course-button-component>

                                                    <p class="included">Included in your plan.</p>
                                                </template>
                                                <template v-else>
                                                    <p class="included">Not available as part of your trial.</p>
                                                </template>
                                            </template>
                                            <template v-else>
                                                <a :href="'/subscribe?return=' + vodCourse.uri" class="btn btn-primary btn-slimpad btn-block btn-white">Upgrade membership</a>

                                                <p class="price">
                                                    <small>
                                                        If you have a discount coupon, apply it on checkout
                                                    </small>
                                                </p>

                                                <p class="mb-0 mt-4">
                                                    <img src="/img/mobile-wallets.png" alt="Payment methods" class="cards" />
                                                </p>
                                            </template>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row justify-content-center" v-if="!(isSubscribed && userTier == 'premium')">
                        <div class="col-md-10">
                            <div class="or"><span>or</span></div>
                        </div>
                    </div>

                    <!-- Show the One-off box -->
                    <div class="row justify-content-center" v-if="!(isSubscribed && userTier == 'premium')">
                        <div class="col-md-10">
                            <div class="block left">
                                <div class="row">
                                    <div class="col-12 col-lg-8">
                                        <h3>
                                            Start learning
                                        </h3>

                                        <ul>
                                            <li>Watch at any time</li>
                                            <li>One time purchase, unlimited views</li>
                                            <li><a href="#classes">{{ vodCourse.numClasses }} classes</a>, total of {{ vodCourse.totalDuration }}</li>
                                            <li>Learn about {{ vodCourse.skillsFriendlyLabel }}</li>
                                            <li>Includes course guide PDF download</li>
                                        </ul>
                                    </div>
                                    <div class="col-12 col-lg-4 meta-col d-flex align-items-stretch">
                                        <div class="meta-info">
                                            <template v-if="isAuth">
                                                <button @click="buyClick" class="btn btn-primary btn-slimpad btn-block btn-white">Buy Now</button>
                                            </template>
                                            <template v-else>
                                                <a :href="'/register?return=' + vodCourse.uri" class="btn btn-primary btn-slimpad btn-block btn-white">Buy Now</a>
                                            </template>

                                            <p class="price">£{{ vodCourse.price }}</p>
                                            <p class="mb-0 mt-4">
                                                <img src="/img/mobile-wallets.png" alt="Payment methods" class="cards" />
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </template>
                <!-- EO PAID -->
            </template>
            <!-- EO ENROLLED -->
        </template>
        <!-- EO LEAN -->

        <template v-if="!vodCourse.isUserEnrolled && !isFree && !(isSubscribed && userTier == 'premium')">
            <b-modal ref="buyModal" size="lg" :title="'Purchase ' + vodCourse.name" :ok-only="true" ok-variant="link" ok-title="Close" centered>
                <buy-vod-course-button-component
                    :vod-course="vodCourse"
                    :slug="vodCourse.slug"
                    :user="user"
                    :is-new-user="isNewlyRegistered"></buy-vod-course-button-component>
            </b-modal>
        </template>
    </div>
</template>

<script>
export default {
    props: {
        vodCourse: {
            type: Object,
            required: true,
        },
        isLean: {
            type: Boolean,
            default: false,
        }
    },

    data() {
        return {
            isAuth: false,
            user: {},
            id: null,
            isBusy: false,
            isFree: false,
            isSubscribed: false,
            isNewlyRegistered: false,
            isFreemiumUser: false,
            isSchoolUser: false,
            credits: 0,
            userTier: null,
        }
    },

    mounted() {
        // User logged in?
        if(window.virtuoso) {
            if(window.virtuoso.is_auth) {
                this.isAuth = true;
                this.user = window.virtuoso.user;
                this.isFreemiumUser = this.user.isFreemium;
                this.isSchoolUser = this.user.isSchoolUser;
            }
            this.isSubscribed = window.virtuoso.is_subscribed;
            this.userTier = window.virtuoso.tier;

            if(this.isSubscribed) {
                this.credits = window.virtuoso.credits;
            }
        }

        this.isFree = this.vodCourse.is_free; // We check server side so it's safe to do whatever here

        this.isNewlyRegistered = new URL(location.href).searchParams.get('registered') ? true : false;
    },

    methods: {
        // Clicked to apply for a seat
        buyClick() {
            this.$refs['buyModal'].show('buyModal');
        },
    }
}
</script>
